import { Component, Input, ViewChild } from '@angular/core';
import { NgScrollbar } from 'ngx-scrollbar';

/** Subset of ngx-perfect-scrollbar config used by this app. */
export interface PerfectScrollbarConfigInterface {
  suppressScrollX?: boolean;
  suppressScrollY?: boolean;
  [key: string]: unknown;
}

/**
 * Drop-in replacement for ngx-perfect-scrollbar (non-Ivy) using ngx-scrollbar.
 * Exposes `directiveRef` with the methods callers already use.
 */
@Component({
  standalone: false,
  selector: 'perfect-scrollbar',
  template:
    '<ng-scrollbar #sb [orientation]="orientation" visibility="native" class="ps-shim"><ng-content></ng-content></ng-scrollbar>',
  styles: [
    `
      :host {
        display: block;
        height: 100%;
      }
      .ps-shim {
        display: block;
        height: 100%;
      }
    `,
  ],
})
export class PerfectScrollbarShimComponent {
  @Input('perfectScrollbar') set psConfig(c: PerfectScrollbarConfigInterface | undefined) {
    if (!c) {
      this.orientation = 'auto';
      return;
    }
    if (c.suppressScrollX && !c.suppressScrollY) {
      this.orientation = 'vertical';
    } else if (c.suppressScrollY && !c.suppressScrollX) {
      this.orientation = 'horizontal';
    } else {
      this.orientation = 'auto';
    }
  }

  orientation: 'vertical' | 'horizontal' | 'auto' = 'vertical';

  @ViewChild('sb', { static: false }) private ngScrollbar?: NgScrollbar;

  get directiveRef() {
    const sb = this.ngScrollbar;
    return {
      scrollToElement: (selector: string, _offset?: number, duration?: number) =>
        sb?.scrollToElement(selector, { duration: duration ?? 500 }),
      scrollTo: (x: number, y: number, duration?: number) =>
        sb?.scrollTo({ top: y, left: x, duration: duration ?? 0 }),
      scrollToBottom: (relativeY?: number, duration?: number) =>
        sb?.scrollTo({ bottom: relativeY ?? 0, duration: duration ?? 500 }),
      update: () => sb?.update(),
    };
  }
}
